<ng-container *ngIf="(currentView$ | async) === MODAL_VIEW.VERSIONING">
  <div mat-dialog-title>
    <span>{{ 'VERSIONING.MAKE_READY_TITLE' | translate }}</span>
    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-info-message *ngIf="error" type="error">
    {{ error | translate }}
  </q9-info-message>

  <mat-dialog-content>
    <form [formGroup]="form" class="form-content" #formTemplate="ngForm">
      <q9-select
        formControlName="release"
        [label]="'CORE.ATTACHMENTS.RELEASE_LABEL'"
        [loading]="isLoading().releases"
        (ngModelChange)="releaseSelected($event)">
        <q9-option>
          <span>{{ 'VERSIONING.NONE_SELECTED' | translate }}</span>
        </q9-option>
        <q9-option [value]="newRelease">
          <span>{{ newRelease.name | translate }}</span>
        </q9-option>
        <q9-option *ngFor="let release of releases" [value]="release">
          <span>{{ release.name | htmlEncoder: true }}</span>
          <span>({{ release.targetReleaseDate | date: 'MMMM dd, yyyy' : 'UTC' }})</span>
        </q9-option>
      </q9-select>

      <q9-textarea-field
        formControlName="comment"
        [minRows]="3"
        [maxRows]="10"
        [label]="'COMMENTS.ADD_COMMENT'"></q9-textarea-field>

      <q9-text-field
        *ngIf="havePassword"
        formControlName="password"
        type="password"
        [label]="'POPUPS.ENTER_PASSWORD'"></q9-text-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <mat-slide-toggle [formControl]="childrenControl">
      {{ 'VERSIONING.INCLUDE_LOWER_LEVEL' | translate }}
    </mat-slide-toggle>

    <q9-secondary-button mat-dialog-close>
      {{ 'VERSIONING.CANCEL_BTN' | translate }}
    </q9-secondary-button>

    <q9-primary-button
      [isLoading]="isLoading().submit"
      (click)="formTemplate.onSubmit($event); onSubmit()">
      {{ 'VERSIONING.CONFIRM_BTN' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</ng-container>

<app-create-release-dialog
  *ngIf="(currentView$ | async) === MODAL_VIEW.RELEASE"
  (switchToVersioning)="switchToVersioning()"
  (releaseCreated)="onCreateRelease($event)"></app-create-release-dialog>
